<template>
	<div id="publishers-formats" class="formats">
		<div class="formats__wrapper">
			<div class="formats__container container">
				<div class="formats__header">
					<h2 class="formats__title heading h2">
						{{ $t('pages.publishers.sections.formats.title') }}
					</h2>
					<button type="button" class="common-btn" @click="publisherModal.openModal">
						{{ $t('pages.publishers.sections.formats.ctaButton') }}
					</button>
				</div>
				<div class="formats__content">
					<BlocksPublishersFormatTabs :tabs="tabs">
						<template #tab-content-1>
							<BlocksPublishersFormatTabBanners />
						</template>
						<template #tab-content-2>
							<BlocksPublishersFormatTabVideo />
						</template>
						<template #tab-content-3>
							<BlocksPublishersFormatTabInterstitial />
						</template>
						<template #tab-content-4> 3 </template>
					</BlocksPublishersFormatTabs>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup lang="ts">
	const { tm } = useI18n()
	const tabs = computed(
		() => tm('pages.publishers.sections.formats.tabs') as { title: string; soon?: string }[]
	)

	const publisherModal = usePublisherModal()
</script>
<style lang="scss" scoped>
	.formats {
		position: relative;
		z-index: 1;
		padding: 0 50px;
		background-color: #f5f5f5;
		border-radius: 90px 90px 0 0;

		@media (width <= 1199px) {
			padding: 0 16px;
			border-radius: 20px 20px 0 0;

			// border-radius: 40px 40px 0 0;
			// border-radius: 40px;
		}
		@media (width <= 575.98px) {
			padding: 0;
		}
		&__header {
			display: flex;
			align-items: center;
			justify-content: space-between;

			@media (width <= 767.98px) {
				flex-direction: column;
				gap: 24px;
				align-items: center;
				justify-content: center;
			}
		}
		&__title {
			text-transform: uppercase;
		}
		&__wrapper {
			padding: 64px 0;

			@media (width <= 1199px) {
				padding: 40px 0 60px;
			}
		}
		&__content {
			margin-top: 64px;
		}
	}
</style>
